import { PyramidalShareholderSearchFilter } from '../../models/pyramidalShareholderSearchFilter';

export interface IPyramidalShareholderListState {
  searchFilter: Partial<PyramidalShareholderSearchFilter>;
  currentPage: number;
  pageSize: number;
  sortBy: string;
  ascending: boolean;
}

export const initialPyramidalShareholderListState: IPyramidalShareholderListState = {
  searchFilter: {},
  currentPage: 1,
  pageSize: 10,
  sortBy: 'name',
  ascending: true
};
